/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IEcommContentTemplate5 contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum imageAlignment {
    left = 'left',
    right = 'right'
}

export interface IEcommContentTemplate5Config extends Msdyn365.IModuleConfig {
    title?: string;
    enablePrimaryColour?: boolean;
    description?: Msdyn365.RichText;
    image?: Msdyn365.IImageData;
    imageAlignment?: imageAlignment;
    firstButton?: IFirstButtonData;
    secondButton?: ISecondButtonData;
    anchorID?: string;
    className?: string;
}

export interface IFirstButtonData {
    text?: string;
    link?: Msdyn365.ILinkData;
    anchorTargetID?: string;
    alternateColor?: boolean;
    className?: string;
}

export interface ISecondButtonData {
    text?: string;
    link?: Msdyn365.ILinkData;
    anchorTargetID?: string;
    alternateColor?: boolean;
    className?: string;
}

export interface IEcommContentTemplate5Props<T> extends Msdyn365.IModule<T> {
    config: IEcommContentTemplate5Config;
}
